class DetailsModal extends HTMLElement {
	constructor() {
		super();
		this.detailsContainer = this.querySelector('details');
		this.summaryToggle = this.querySelector('summary');
		this.input = this.detailsContainer.querySelector('input:not([type="hidden"])');

		this.detailsContainer.addEventListener('keyup', (event) => {
			if (event.code.toUpperCase() === 'ESCAPE') this.close();
		});

		this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
		this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));
		this.summaryToggle.setAttribute('role', 'button');

		const nv = document.querySelector('.nv');
		
		if (nv) {
			nv.addEventListener('mouseenter', () => {
				if (document.body.classList.contains('nv--on')) return;
				if (this.isOpen()) this.close(false);
			});
		}

		if (this.closest('.nv')) {
			this.syncNvState();
			this.bodyClassObserver = new MutationObserver(() => this.syncNvState());
			this.bodyClassObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
		}

		if (this.input) {
			this.input.addEventListener('input', () => {
				if (this.input.value.trim().length > 0) {
					$('header').addClass('sc__');
				} else {
					$('header').removeClass('sc__');
				}
			});
		}

		this.onScCloseClick = this.handleScCloseClick.bind(this);
		document.addEventListener('click', this.onScCloseClick);
	}

	disconnectedCallback() {
		if (this.bodyClassObserver) this.bodyClassObserver.disconnect();
		if (this.onScCloseClick) document.removeEventListener('click', this.onScCloseClick);
	}

	handleScCloseClick(event) {
		const closeBtn = event.target.closest('.sc__clos-btn');
		if (!closeBtn) return;

		this.resetAndClose();
	}

	isOpen() {
		return this.detailsContainer.hasAttribute('open');
	}

	syncNvState() {
		const isNvOn = document.body.classList.contains('nv--on');

		if (isNvOn && !this.isOpen()) {
			this.openFromNv();
		} else if (!isNvOn && this.isOpen()) {
			if (this.input) this.input.value = '';
			$('header').removeClass('sc__');
			this.close(false);
		}
	}

	resetAndClose() {
		if (this.input) {
			this.input.value = '';
			this.input.dispatchEvent(new Event('input', { bubbles: true }));
			this.input.dispatchEvent(new Event('change', { bubbles: true }));
		}
		$('header').removeClass('sc__');
		this.close(false);
	}

	onSummaryClick(event) {
		event.preventDefault();
		event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
	}

	onBodyClick(event) {
		if (document.body.classList.contains('nv--on')) return;

		if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) {
			this.resetAndClose();
		}
	}

	open(event) {
		this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
		event.target.closest('details').setAttribute('open', true);
		document.body.addEventListener('click', this.onBodyClickEvent);
		document.body.classList.add('overflow-hidden');

		if (this.classList.contains('header__search')) {
			$('header').addClass('sc-on');
		}

		trapFocus(
			this.detailsContainer.querySelector('[tabindex="-1"]'),
			this.detailsContainer.querySelector('input:not([type="hidden"])')
		);
	}

	openFromNv() {
		this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
		this.detailsContainer.setAttribute('open', true);
		document.body.addEventListener('click', this.onBodyClickEvent);
		document.body.classList.add('overflow-hidden');

		if (this.classList.contains('header__search')) {
			$('header').addClass('sc-on');
		}

		trapFocus(
			this.detailsContainer.querySelector('[tabindex="-1"]'),
			this.detailsContainer.querySelector('input:not([type="hidden"])')
		);
	}

	close(focusToggle = true) {
		removeTrapFocus(focusToggle ? this.summaryToggle : null);
		this.detailsContainer.removeAttribute('open');
		document.body.removeEventListener('click', this.onBodyClickEvent);
		document.body.classList.remove('overflow-hidden');

		if (this.classList.contains('header__search')) {
			$('header').removeClass('sc-on');
		}
	}
}

customElements.define('details-modal', DetailsModal);